import React from 'react';
import RichTextEditor from 'react-rte';

const TOOLBAR = {
  display: ['INLINE_STYLE_BUTTONS', 'BLOCK_TYPE_BUTTONS', 'LINK_BUTTONS', 'BLOCK_TYPE_DROPDOWN', 'HISTORY_BUTTONS'],
  INLINE_STYLE_BUTTONS: [
    { label: 'Bold', style: 'BOLD' },
    { label: 'Italic', style: 'ITALIC' },
    { label: 'Underline', style: 'UNDERLINE' },
  ],
  BLOCK_TYPE_DROPDOWN: [
    { label: 'Normal', style: 'unstyled' },
    { label: 'Heading large', style: 'header-one' },
    { label: 'Heading medium', style: 'header-two' },
    { label: 'Heading small', style: 'header-three' },
  ],
  BLOCK_TYPE_BUTTONS: [
    { label: 'Bulleted list', style: 'unordered-list-item' },
    { label: 'Numbered list', style: 'ordered-list-item' },
  ],
};

// A rich text field bound to an HTML string (react-rte, as before). The editor
// rewrites HTML its own way, so nothing is written back until the text really
// changes: opening or clicking into a field isn't an edit. When the value is
// replaced from outside (a save or reload), the editor shows the new one.
export default class RichText extends React.Component {
  constructor(props) {
    super(props);
    this.state = { editorState: this.seed(props.value) };
  }

  componentDidUpdate(prevProps) {
    const { value } = this.props;
    if (value !== prevProps.value && value !== this.lastEmitted) {
      this.setState({ editorState: this.seed(value) });
    }
  }

  seed(value) {
    const editorState = RichTextEditor.createValueFromString(value || '', 'html');
    this.seedHtml = editorState.toString('html');
    this.lastEmitted = value;
    return editorState;
  }

  onChange = (editorState) => {
    this.setState({ editorState });
    const html = editorState.toString('html');
    if (html === this.seedHtml && this.lastEmitted === this.props.value) return;
    if (html === this.lastEmitted) return;
    this.lastEmitted = html;
    this.props.onChange(html);
  };

  render() {
    const { placeholder, id, label } = this.props;
    return (
      <div className="de-rich" id={id} aria-label={label}>
        <RichTextEditor
          value={this.state.editorState}
          onChange={this.onChange}
          toolbarConfig={TOOLBAR}
          placeholder={placeholder}
          className="de-rich__editor"
          toolbarClassName="de-rich__toolbar"
          editorClassName="de-rich__body"
        />
      </div>
    );
  }
}
